import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AuthLayout from "../../components/auth/AuthLayout";
import LoginForm from "../../components/auth/LoginForm";
import { get, post } from "../../api/apiService";
import { useAuthContext } from "../../context/AuthContext";

const LoginPage: React.FC = () => {
  const location = useLocation();
  const message = location.state?.message;
  const navigate = useNavigate();
  const { setUserData } = useAuthContext();

  React.useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('t');
    if (!token) return;

    const handleToken = async () => {
      try {
        localStorage.setItem('AUTH_TOKEN', token);
        localStorage.setItem('rkb_token', token);

        let res: any;
        try {
          res = await get('/user/me');
        } catch (err) {
        
        }

        console.log('res.data::: ', res.data);
        if (res && (res.data)) {
          const user = res.data;
          // Updates AuthContext's in-memory state too, not just localStorage —
          // role-gated routes read from context and won't see a plain
          // localStorage write until the next async refresh.
          setUserData(user);

          setTimeout(() => {
            if (user.isAdmin) navigate('/dashboard');
            else navigate('/user-dashboard');
            
          }, 1000);
        }
      } catch (err) {
        console.error('Failed to validate token from URL', err);
      } finally {
        try {
          navigate(location.pathname, { replace: true });
        } catch (_) {}
      }
    };

    handleToken();
  }, [location.search]);

  return (
    <AuthLayout title="Welcome Back" subtitle="Sign in to your account" allowScroll={false}  showLogo={true}>
      {message && (
        <div className="mb-4 p-3 bg-green-50 border border-green-200 rounded-lg">
          <p className="text-sm text-green-800">{message}</p>
        </div>
      )}
      <LoginForm />
    </AuthLayout>
  );
};

export default LoginPage;
